import { render } from "./Rains.vue?vue&type=template&id=28644e59"
import script from "./Rains.vue?vue&type=script&lang=js"
export * from "./Rains.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__